import React from "react";
import styled from "styled-components";

const SubTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
`;

export default SubTitle;
